import React, { useContext, useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { ContactContext } from "../context/contact/ContactContext";
import EstadoCuenta from "../components/EstadoCuenta/EstadoCuenta";
import Approvals from "../components/Vendor/Contact/Approvals";
import Information from "../components/Vendor/Contact/Information";
import ApprovalForm from "../components/Vendor/Contact/Approval";
import NonApproved from "../components/Vendor/NonApproved";
import PendingApproval from "../components/Vendor/PendingApproval";
import Enrollment from "../components/Vendor/Enrollment";
import OpenPurchaseOrders from "../components/Vendor/Purch/Open";
import ClosedPurchaseOrders from "../components/Vendor/Purch/Closed";
import PurchaseOrdersReceived from "../components/Vendor/Purch/Received";
import ManageInformation from "../components/Vendor/ManageInformation";
import ManageBankInformation from "../components/Vendor/ManageBankInformation";
import ManageGeneralInformation from "../components/Vendor/ManageGeneralInformation";
import ManageDocumentation from "../components/Vendor/ManageDocumentation";
import CreateBank from "../components/Vendor/ManageBankInformation/CreateBank";
import Carrier from "../components/Vendor/Shipper";
import UpdateContactnformation from "../components/Vendor/Contact/Information/Update";
import DownloadDocument from "../components/Vendor/Contact/Information/Download";

const ProtectedRoutes = () => {
  const {
    isActivePrimary,
    isActiveSecondary,
    exist,
    isActive,
    isApproved,
    isPendingApproval,
    isSecondary,
    startEnrollment,
    enrollment,
  } = useContext(ContactContext);
  const [heightNavLife, setheightNavLife] = useState(0);

  const updateWindowDimensions = () => {
    setheightNavLife(
      document.getElementById("navLife").clientHeight +
        document.getElementById("navPortal").clientHeight +
        20
    );
  };
  window.addEventListener("resize", updateWindowDimensions);

  // useEffect(() => {
  //   const fetchData2 = async () => {
  //     await Promise.all([getStatesContact()]);
  //   };
  //   fetchData2();
  // }, []);

  // #region States
  //(false, false, false, false, false) => es nuevo usuario (primaryContact o SecondaryContact) y es primer ingreso
  //luego en el Back se comprueba si hay un primaryContact
  const cond0 =
    !isActive && !isApproved && !isPendingApproval && !isSecondary && !exist;

  //(true, true, false, false, true) => es primaryContact
  const cond1 =
    isActive && isApproved && !isPendingApproval && !isSecondary && exist;

  //(false, false, true, false, true) => es primaryContact y está pendiente de aprobación
  const cond2 =
    !isActive && !isApproved && isPendingApproval && !isSecondary && exist;

  //(false, false, false, false, true) => es primaryContact y no pasó la aprobación
  const cond3 =
    !isActive && !isApproved && !isPendingApproval && !isSecondary && exist;

  //(true, true, false, true, true) => es SecondaryContact
  const cond4 =
    isActive && isApproved && !isPendingApproval && isSecondary && exist;

  //(false, false, true, true, true) => es SecondaryContact y está pendiente de aprobación
  const cond5 =
    !isActive && !isApproved && isPendingApproval && isSecondary && exist;

  //(false, false, false, true, true) => es SecondaryContact y no pasó la aprobación
  const cond6 =
    !isActive && !isApproved && !isPendingApproval && isSecondary && exist;
  // #endregion
  // console.log(isActivePrimary);
  // console.log(isActiveSecondary);
  // console.log(enrollment);
  // if (enrollment) {
  //   navigate("/Vendor/Enrollment");
  // }

  useEffect(() => {
    async function fetchData() {
      setheightNavLife(
        document.getElementById("navLife").clientHeight +
          document.getElementById("navPortal").clientHeight +
          20
      );
    }
    fetchData();
  }, []);

  return (
    <div style={{ marginTop: heightNavLife }}>
      <Routes>
        {(isActivePrimary || isActiveSecondary) && (
          <>
            <Route path="/" element={<Information />} />
            <Route path="/Vendor/AccountStatus" element={<EstadoCuenta />} />
            <Route path="/Vendor/Purch/Open" element={<OpenPurchaseOrders />} />
            <Route
              path="/Vendor/Purch/Closed"
              element={<ClosedPurchaseOrders />}
            />
            <Route
              path="/Vendor/Purch/Recieved"
              element={<PurchaseOrdersReceived />}
            />
            <Route
              path="/Contact/Information/Update"
              element={<UpdateContactnformation />}
            />
            <Route
              path="/Contact/Information/Download"
              element={<DownloadDocument />}
            />
          </>
        )}
        {isActivePrimary && (
          <>
            <Route path="/Vendor/Contact/Approvals" element={<Approvals />} />
            <Route path="/Vendor/Carrier" element={<Carrier />} />
            <Route
              path="/Vendor/CompanyInformation"
              element={<ManageInformation />}
            />
            {/* <Route
              path="/Vendor/BankInformation"
              element={<ManageBankInformation />}
            /> */}
            <Route
              path="/Vendor/GeneralInformation"
              element={<ManageGeneralInformation />}
            />
            <Route
              path="/Vendor/Documentation"
              element={<ManageDocumentation />}
            />
            <Route path="/Vendor/Bank/Create" element={<CreateBank />} />
          </>
        )}

        {startEnrollment &&
          enrollment &&
          !isActivePrimary &&
          !isActiveSecondary && (
            <Route path="/Vendor/Enrollment" element={<Enrollment />} />
          )}
      </Routes>
      {cond0 && !startEnrollment ? (
        <ApprovalForm />
      ) : cond2 || cond5 ? (
        <PendingApproval />
      ) : (
        (cond3 || cond6) && <NonApproved />
      )}
    </div>
  );
};

export default ProtectedRoutes;
